"use client"

import { RefreshCwOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RefreshCwOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RefreshCwOffIcon = component(Icon)({ as: RefreshCwOff })
